<template>
  <!-- Navbar start -->
  <nav class="w-screen fixed bg-opacity-90 bg-white p-4 lg:px-20 flex justify-between z-50">
    <!-- Logo and Text start -->
    <div class="h-full flex items-end">
      <img src="@/assets/images/logo/mme_logo_only.webp" alt="Mozgásban Maradók Egyesülete"
        class="h-16 w-auto max-w-full mr-4" />
      <span class="text-lg font-bold leading-tight uppercase relative" style="top: 5px; right: 5px">
        Mobil<br />Mászófal
      </span>
    </div>
    <!-- Logo and Text end -->

    <!-- Toggler start -->
    <button role="menubar" class="md:hidden" @click="navToggle">
      <i class="fa-solid fa-bars text-2xl"></i>
    </button>
    <!-- Toggler end -->

    <!-- Menu content start -->
    <div
      class="absolute left-0 right-0 translate-y-20 bg-opacity-90 bg-white md:bg-none md:bg-opacity-0 shadow md:flex flex-col gap-4 items-center p-4 md:flex-row md:static md:shadow-none md:translate-y-0"
      role="menu" :aria-expanded="isMenuOpen" :class="{ hidden: !isMenuOpen, flex: isMenuOpen }">
      <!-- Links start -->
      <a href="#" role="menuitem" :class="{ 'text-green-500 font-bold': activeSection === 'home' }" class="mx-4">
        Kezdőlap
      </a>

      <a href="#about" role="menuitem" :class="{ 'text-green-500 font-bold': activeSection === 'about' }" class="mx-4">
        Rólunk
      </a>

      <a href="#climbing-wall" role="menuitem"
        :class="{ 'text-green-500 font-bold': activeSection === 'climbing-wall' }" class="mx-4">
        Mászófal
      </a>

      <a href="#games" role="menuitem" :class="{ 'text-green-500 font-bold': activeSection === 'games' }" class="mx-4">
        Játékok
      </a>

      <a href="#gallery" role="menuitem" :class="{ 'text-green-500 font-bold': activeSection === 'gallery' }"
        class="mx-4">
        Galéria
      </a>

      <a href="#contact" class="btn bg-green hover:bg-green-dark text-white" role="menuitem"
        :class="{ 'font-bold': activeSection === 'contact' }">
        Kapcsolat
      </a>
      <!-- Links end -->
    </div>
    <!-- Menu content end -->
  </nav>
  <!-- Navbar end -->
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false, // Reaktív állapot a menü megjelenítéséhez
      activeSection: 'home', // Az éppen látható szekció azonosítója, alapértelmezett: 'home'
    };
  },
  methods: {
    navToggle() {
      this.isMenuOpen = !this.isMenuOpen; // Állapot váltása
    },
    observeSections() {
      const sections = document.querySelectorAll('section[id]');
      const updateActiveSection = () => {
        let active = null;
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
            active = section.id;
          }
        });
        if (active) {
          this.activeSection = active; // Az aktív szekció frissítése
        }
      };

      window.addEventListener('scroll', updateActiveSection);
      updateActiveSection(); // Azonnali frissítés betöltéskor
    },
    resetToHome() {
      // Ha az oldal tetejére görgetsz, állítsa vissza a kezdőlapot aktívra
      window.addEventListener('scroll', () => {
        if (window.scrollY === 0) {
          this.activeSection = 'home';
        }
      });
    },
  },
  mounted() {
    this.observeSections(); // Szekciók figyelése a komponens betöltésekor
    this.resetToHome(); // Kezdőlap visszaállítása az oldal tetején
  },
};
</script>

<style>
.text-green-500 {
  color: #6eb31a !important;
  /* Aktív gomb szöveg színe */
}

.font-bold {
  font-weight: bold;
  /* Aktív gomb vastag betű */
}

.bg-green {
  background-color: #5a9314 !important;
  /* Kapcsolat gomb zöld háttér */
}

.hover\:bg-green-dark:hover {
  background-color: #05650c;
  /* Kapcsolat gomb sötétebb zöld hover */
}

.text-white {
  color: #ffffff;
  /* Kapcsolat gomb fehér szöveg */
}
</style>